import { Popover, PopoverBody, PopoverContent, PopoverTrigger, Text, Box } from '@chakra-ui/react'

type Props = {
  trigger: React.ReactNode
  title: string
  description: string
}

export function RequestPreviewPopover({ trigger, title, description }: Props) {
  return (
    <Popover trigger="hover" placement="bottom-start" openDelay={200} closeDelay={150}>
      <PopoverTrigger>{trigger as any}</PopoverTrigger>

      <PopoverContent
        w="560px"
        borderRadius="xl"
        boxShadow="lg"
        _focus={{ boxShadow: 'lg' }}
        pointerEvents="auto"
      >
        <PopoverBody p={4}>
          <Box mb={2}>
            <Text fontWeight="semibold">{title}</Text>
          </Box>
          <Text fontSize="sm" color="gray.700" whiteSpace="pre-wrap">
            {description}
          </Text>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  )
}